import React, {useEffect, useState} from 'react';
import {AtSwitch} from "taro-ui";
import {LabelWidget} from "../../index";

const TSwitchWidget = (props:any) => {
  const {
    label,
    value:wValue,
    border,
    isDisabled,
    updateWidgetProperty,
    fontSize,
    color,
    bgColor,
    fontStyle,
    labelWidth,
    labelPosition,
    labelAlignment,
    placeholderAlignment,
    defaultValue
  } = props;
  const [value, setValue] = useState<boolean>(defaultValue);
  useEffect(()=>{
    setValue(wValue)
  }, [wValue]);
  return (
    <LabelWidget label={label}
                 fontSize={fontSize}
                 color={color}
                 fontStyle={fontStyle}
                 bgColor={bgColor}
                 labelWidth={labelWidth}
                 labelAlignment={labelAlignment}
                 labelPosition={labelPosition}
                 placeholderAlignment={placeholderAlignment}
    >
      <AtSwitch
        border={border}
        disabled={isDisabled}
        checked={value}
        onChange={(v:boolean)=>{
          setValue(v);
          updateWidgetProperty&&updateWidgetProperty(v);
        }} />

    </LabelWidget>
  );
};

export default TSwitchWidget;
